import React, { Component, PropTypes } from 'react';
import { NitroIcon } from 'nitro-components';
import styled from 'styled-components';

import FilterDrawer from '../filter/FilterDrawer';

const SourceFilters = styled.div`
  position: fixed;
  z-index: 1000;
  left: 0;
  opacity: 0.95;
  bottom: 16px;
  transition: transform 0.2s ease-in;
  text-align: center;
  width: 100%;
`;

const FilterButtonWrapper = styled.section`
  background: ${props => props.theme.color.white};
  border-radius: 100px;
  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.2);
  color: ${props => props.theme.color.secondary};
  display: inline-block;
  font-family: ${props => props.theme.font.bold};
  min-width: 150px;
`;

const FilterButton = styled.button`
  display: inline-block;
  padding: 8px 10px;
  border: 0;
  border-left: 1px solid #f0f0f0;
  outline: 0;
  font: inherit;
  cursor: pointer;
  background: none;

  ${props => props.noBorder && 'border-left-width: 0;'}
`;

class FilterMobileComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      filterBy: '',
      filters: [],
    };
  }

  closeFilters = () => {
    this.setState({ open: false });
  };

  applyFilters = filters => {
    if (this.state.filterBy === 'Source' && filters.length) {
      this.props.onClickSource(filters);
    } else if (this.state.filterBy === 'Filter' && filters.length) {
      this.props.onClickFilter(filters);
    } else if (this.state.filterBy === 'View by' && filters.length) {
      this.props.onClickCategory(filters[0].value);
    }
    this.closeFilters();
  };

  handleSourceClick = () => {
    this.setState({
      filterBy: 'Source',
      open: true,
      filters: this.props.source,
    });
  };

  handleFilterClick = () => {
    this.setState({
      filterBy: 'Filter',
      open: true,
      filters: this.props.filters,
    });
  };

  handleCategoryClick = () => {
    this.setState({
      filterBy: 'View by',
      open: true,
      filters: this.props.categories,
    });
  };

  render() {
    return (
      <div>
        <SourceFilters>
          <FilterButtonWrapper>
            <FilterButton noBorder onClick={this.handleSourceClick}>
              <NitroIcon
                name="source"
                size={16}
                variant="secondary"
                right={12}
              />
              <span>Source</span>
            </FilterButton>
            {this.props.filter ? (
              <FilterButton onClick={this.handleFilterClick}>
                <NitroIcon
                  name="filter"
                  size={16}
                  variant="secondary"
                  right={12}
                />
                <span>Filter</span>
              </FilterButton>
            ) : null}
            {this.props.showCategories ? (
              <FilterButton onClick={this.handleCategoryClick}>
                <NitroIcon
                  name="filter-search"
                  size={20}
                  variant="secondary"
                  right={12}
                />
                <span>View by</span>
              </FilterButton>
            ) : null}
          </FilterButtonWrapper>
        </SourceFilters>
        <FilterDrawer
          action={this.applyFilters}
          open={this.state.open}
          close={this.closeFilters}
          title={this.state.filterBy}
          filters={this.state.filters}
          validator={this.props.validator}
        />
      </div>
    );
  }
}
FilterMobileComponent.propTypes = {
  onClickSource: PropTypes.func,
  onClickFilter: PropTypes.func,
  onClickCategory: PropTypes.func,
  filter: PropTypes.bool,
  source: PropTypes.array,
  filters: PropTypes.array,
  categories: PropTypes.array,
  validator: PropTypes.func,
  showCategories: PropTypes.bool,
};

export default FilterMobileComponent;



// WEBPACK FOOTER //
// ./src/components/common/FilterMobileComponent.js